import { CheckoutState } from './checkoutState';

export type Step = 'auth' | 'shipping' | 'payment';

export const getInitialStep = (checkoutState: CheckoutState): Step => {
  if (!checkoutState.customer) {
    return 'auth';
  } else if (!checkoutState.orderState.addresses?.shipping) {
    return 'shipping';
  } else {
    return 'payment';
  }
};
